import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import Creators from "@/pages/Creators";
import Categories from "@/pages/Categories";
import About from "@/pages/About";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Profile from "@/pages/Profile";
import ProjectDetail from "@/pages/ProjectDetail";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import CollectionDetail from "@/pages/CollectionDetail";
import ResetPassword from "@/pages/ResetPassword";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/explore" element={<Explore />} />
      <Route path="/creators" element={<Creators />} />
      <Route path="/categories" element={<Categories />} />
      <Route path="/about" element={<About />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/reset" element={<ResetPassword />} />
      <Route path="/u/:username" element={<Profile />} />
      <Route path="/project/:id" element={<ProjectDetail />} />
      <Route path="/collections/:id" element={<CollectionDetail />} />
      <Route path="/dashboard/*" element={<Dashboard />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
